import React from 'react'

import Experience from "./Experience"
import Education from "./Education"

const ResumeSubCard = () => {
    return (
        <div className="content resume">

            <div className="title">Resume</div>


            <div className="row">

                <Experience />

                <Education />

                <div className="clear"></div>
            </div>

        </div>
    );
}

export default ResumeSubCard;